import React, { ReactElement } from 'react';
import { Network } from '@types';
import clsx from 'clsx';
import { IsNativeToken } from '@lib/utils';

interface TokenTypeLabelProps {
  toNetwork: Network;
  symbol: string;
  className?: string;
}

const TokenTypeLabel = ({
  toNetwork,
  symbol,
  className,
}: TokenTypeLabelProps): ReactElement => {
  if (IsNativeToken({ network: toNetwork, symbol })) return <></>;

  let label = '';
  if (toNetwork === Network.Ethereum) {
    label = 'ERC-20';
  } else if (toNetwork === Network.Cronos) {
    label = 'CRC-20';
  } else if (toNetwork === Network.CryptoOrg) {
    label = 'ICS-20';
  }

  return (
    <span
      className={clsx(
        'rounded-full border border-white text-white flex justify-center w-max px-1 text-[10px]',
        className
      )}
    >
      {label}
    </span>
  );
};

export default TokenTypeLabel;
